/**
 * Registration helpers shared by the extranet domain `register.ts` files.
 */

import {
  isComponentRegistered,
  registerComponent,
  type ComponentRegistration,
} from '@components/shared/configurable';

/** Module slug of every extranet registration (`extranet.<name>`). */
export const EXTRANET_MODULE = 'extranet';

/**
 * Register a component unless its id is already registered — HMR and test
 * re-imports stay idempotent (`registerComponent` throws on duplicates).
 */
export function registerOnce<P>(registration: ComponentRegistration<P>): void {
  if (!isComponentRegistered(registration.id)) {
    registerComponent<P>(registration);
  }
}
